module.exports = __webpack_public_path__ + "img/Puerto Rico.1deaffaf.svg";